module.exports = __webpack_public_path__ + "static/img/logo22.c2387b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo22.png
// module id = xmJ5
// module chunks = 1